import classNames from 'classnames';

import XMarkIcon from '@heroicons/react/20/solid/XMarkIcon';
import { usePurchase } from '../../../context/purchase/usePurchase';
import { PurchaseInfo } from './PurchaseInfo';
import { LoadingLines } from '../../_misc/loaders/LoadingLines';
import { useEffect, useRef, useState } from 'react';

import { SubscriptionInfo } from './SubscriptionInfo';
import { ThemePrimary } from '../../../context/theme/ThemeConstantsUpdated';

const { primaryBackground } = ThemePrimary;

export const OrderConfirmation = (props: Props) => {
  const { isToggled, onContinue, className } = props;
  const wasToggledRef = useRef(isToggled);
  const { completedPurchase, completedSubscription, isRefreshingToken } = usePurchase();
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout>();
  // const [isShowingFireworks, setisShowingFireworks] = useState<boolean>();
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    const wasToggled = wasToggledRef.current;

    if (isToggled && !wasToggled) {
      // Force initial state, then trigger animation
      setShouldAnimate(false);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setShouldAnimate(true);
        });
      });

      // setTimeoutId(
      //   setTimeout(() => {
      //     setisShowingFireworks(true);
      //   }, 2000)
      // );
    } else if (!isToggled && wasToggled) {
      setShouldAnimate(false);
      // setisShowingFireworks(false);
      clearTimeout(timeoutId);
      setTimeoutId(undefined);
    }

    wasToggledRef.current = isToggled;
  }, [isToggled, timeoutId]);

  const commonStripeClassnames = 'loader__tile absolute h-[10%] rounded-r-full';

  const getBarStyle = (delay: number, isActive: boolean) => ({
    transition: 'width 700ms ease-out, left 700ms ease-out',
    transitionDelay: isActive ? `${delay}ms` : '0ms',
    width: isActive ? '120%' : '0%',
    left: isActive ? '0' : '-6rem',
  });

  const getPurchaseInfoStyle = (isActive: boolean) => ({
    transition: 'opacity 500ms ease-out',
    transitionDelay: isActive ? '1300ms' : '0ms',
    opacity: isActive ? 1 : 0,
  });

  return (
    <div
      className={classNames(
        className,
        isToggled ? 'z-[55]' : '-z-10 delay-[1600ms]',
        'absolute flex h-screen w-screen items-center justify-center overflow-auto bg-transparent'
      )}
    >
      <div
        className={classNames(
          'loader fixed inset-0 h-screen bg-transparent transition-all duration-[1400ms]',
          isToggled ? 'w-full' : 'w-0'
        )}
      >
        {/* {isShowingFireworks && (
          <>
            <div className="pyro">
              <div className="before" />
              <div className="after" />
            </div>
            <div className="pyro pyro--alt1">
              <div className="before" />
              <div className="after" />
            </div>
            <div className="pyro pyro--alt2">
              <div className="before" />
              <div className="after" />
            </div>
            <div className="pyro pyro--alt3">
              <div className="after" />
            </div>
            {!isRefreshingToken && (
              <div className="absolute right-8 top-8 z-10 lg:right-16 lg:top-12">
                <button onClick={() => onContinue()} className="p-1 text-white opacity-60 hover:opacity-100">
                  <XMarkIcon className="h-12 w-12 text-white" />
                </button>
              </div>
            )}
          </>
        ) */}

        <div
          className="absolute left-1/2 top-1/2 z-10 w-full max-w-lg -translate-x-1/2 -translate-y-1/2 text-center"
          style={getPurchaseInfoStyle(!!(isToggled && shouldAnimate))}
        >
          {completedPurchase ? (
            <PurchaseInfo purchase={completedPurchase} onContinue={onContinue} />
          ) : completedSubscription ? (
            <SubscriptionInfo subscription={completedSubscription} onContinue={onContinue} />
          ) : (
            <LoadingLines />
          )}
        </div>

        <div
          className={classNames('top-[0%]', primaryBackground, commonStripeClassnames)}
          style={getBarStyle(600, !!(isToggled && shouldAnimate))}
        />
        <div
          className={classNames('top-[10%]', primaryBackground, commonStripeClassnames)}
          style={getBarStyle(800, !!(isToggled && shouldAnimate))}
        />
        <div
          className={classNames('top-[20%]', primaryBackground, commonStripeClassnames)}
          style={getBarStyle(400, !!(isToggled && shouldAnimate))}
        />
        <div
          className={classNames('top-[30%]', primaryBackground, commonStripeClassnames)}
          style={getBarStyle(800, !!(isToggled && shouldAnimate))}
        />
        <div
          className={classNames('top-[40%]', primaryBackground, commonStripeClassnames)}
          style={getBarStyle(600, !!(isToggled && shouldAnimate))}
        />
        <div
          className={classNames('top-[50%]', primaryBackground, commonStripeClassnames)}
          style={getBarStyle(200, !!(isToggled && shouldAnimate))}
        />
        <div
          className={classNames('top-[60%]', primaryBackground, commonStripeClassnames)}
          style={getBarStyle(0, !!(isToggled && shouldAnimate))}
        />
        <div
          className={classNames('top-[70%]', primaryBackground, commonStripeClassnames)}
          style={getBarStyle(400, !!(isToggled && shouldAnimate))}
        />
        <div
          className={classNames('top-[80%]', primaryBackground, commonStripeClassnames)}
          style={getBarStyle(0, !!(isToggled && shouldAnimate))}
        />
        <div
          className={classNames('top-[90%]', primaryBackground, commonStripeClassnames)}
          style={getBarStyle(200, !!(isToggled && shouldAnimate))}
        />
      </div>
    </div>
  );
};

type Props = {
  onContinue: () => void;
  isToggled?: boolean;
  className?: string;
};
